module.exports = __webpack_public_path__ + "static/img/hexibanner6.69d8d7e3.jpg";